import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BidBaseInfo, DataOfTabel1 } from "../interface/make-bid.interface";

@Component({
  selector: "app-bid-table",
  templateUrl: "./bid-table.component.html",
  styleUrls: ["./bid-table.component.scss"]
})
export class BidTableComponent implements OnInit {
  @Input() makeBidEditStatus: boolean;//是否是可编辑标单制定,true为可编辑,false为只读
  @Input() makeBudgetEstimatesStatus: boolean;//是否显示概算制定相关UI
  @Input() editBudgetEstimatesStatus: boolean;//是否是可编辑概算制定,true为可编辑,false为只读
  @Input() produceBudgetStatus: boolean;//是否生成概算(true为显示价格,false为不显示)
  @Input() reviewResultIsReject: boolean;//是否是驳回的UI
  @Input() listOfTable1Data: DataOfTabel1[];
  @Input() listOfBaseMaterialData = [];
  @Input() table2TotalPrice: number;
  @Input() profitTotalPrice: number;
  @Input() taxRatesTotalPrice: number;
  @Input() table1TotalPrice: number;
  @Input() selectColumns = [];
  @Input() table2Columns = [];
  @Input() bidBaseInfor: BidBaseInfo;// 厂商的基本信息和备注信息
  @Input() getProjectCategory: number;
  @Input() step: number;
  @Input() getFormBudgetCharge: object = {};
  @Output() itemChange = new EventEmitter<object>();
  @Output() selectValueChange = new EventEmitter<object>();
  @Output() table1RemarkChanged = new EventEmitter<object>();
  @Output() table1ScaleChanged = new EventEmitter<object>();
  @Output() remarkSelectChange = new EventEmitter<object>();
  @Output() addRow = new EventEmitter<Object>();
  @Output() delRow = new EventEmitter<Object>();
  @Output() addList = new EventEmitter<number>();
  @Output() delList = new EventEmitter<number>();
  @Output() budgetCodeAndCreditDepartmentChange = new EventEmitter<Object>();

  // 付款方式
  monthlyDaysOption = [// 默认是90
    { label: '30', value: '30' },
    { label: '60', value: '60' },
    { label: '90', value: '90' },
    { label: '120', value: '120' },
  ];

  // 保固期
  warrantyPeriodsOption = [
    { label: this.translateService.instant('BidCreat.Remark3Select1'), value: this.translateService.instant('BidCreat.Remark3Select1') },
    { label: `0.5${this.translateService.instant('BidCreat.Remark3Year')}`, value: `0.5${this.translateService.instant('BidCreat.Remark3Year')}` },
    { label: `1${this.translateService.instant('BidCreat.Remark3Year')}`, value: `1${this.translateService.instant('BidCreat.Remark3Year')}` },
    { label: `2${this.translateService.instant('BidCreat.Remark3Years')}`, value: `2${this.translateService.instant('BidCreat.Remark3Years')}` },
    { label: `3${this.translateService.instant('BidCreat.Remark3Years')}`, value: `3${this.translateService.instant('BidCreat.Remark3Years')}` },
    { label: `5${this.translateService.instant('BidCreat.Remark3Years')}`, value: `5${this.translateService.instant('BidCreat.Remark3Years')}` },
    { label: this.translateService.instant('BidCreat.Remark3Select7'), value: this.translateService.instant('BidCreat.Remark3Select7') },
  ];

  // 交货周期
  deliveryCyclesOption = [
    { label: '30', value: '30' },
  ];

  // 报价单有效期
  quoteIndaysOption = [// 默认是90
    { label: '30', value: '30' },
    { label: '60', value: '60' },
    { label: '90', value: '90' },
    { label: '120', value: '120' },
  ];


  // 预算编码 挂账部门
  formBudgetCharge = {};

  constructor(
    private translateService: TranslateService
  ) { }
  ngOnInit(): void {
    // do something
  }
  ngItemChange(event: string, index1: number) {
    this.itemChange.emit({ "event": event, "index1": index1 });
  }
  // select
  ngSelectChange(event: string, name: string, value: object, index1: number, index2: number) {
    this.selectValueChange.emit({ "data": value, "key": name, "value": event, "index1": index1, "index2": index2 });
  }

  nzTable1ScaleChanged(e: string, index: number) {
    this.table1ScaleChanged.emit({ "index": index, "value": e });
  }
  nzTable1RemarkChanged(e: string, index1: number) {
    this.table1RemarkChanged.emit({ "index": index1, "value": e });
  }

  ngRemarkSelectChange(e: string, name: string) {
    this.remarkSelectChange.emit({ "key": name, "value": e });
  }

  addlist(index1: number) {
    this.addList.emit(index1);
  }

  dellist(index1: number) {
    this.delList.emit(index1);
  }

  addrow(index1: number, index2: number) {
    this.addRow.emit({ "index1": index1, "index2": index2 });
  }

  delrow(index1: number, index2: number) {
    this.delRow.emit({ "index1": index1, "index2": index2 });
  }

  ngBudgetCodeAndCreditDepartmentChange(e: string, key: string) {
    this.formBudgetCharge[key] = e;
    this.budgetCodeAndCreditDepartmentChange.emit(this.formBudgetCharge);
  }

  // 指定数字输入框展示值的格式
  formatterPercent = (value: number): string => `${value} %`;
  // 指定从 nzFormatter 里转换回数字的方式，和 nzFormatter 搭配使用
  parserPercent = (value: string): string => value.replace(' %', '');

}
